/** Icon header cho dialog xác nhận (hủy, đổi scope, xóa mốc, …) */
export const LOYALTY_MODAL_ICON = {
  QUESTION: "question",
  DELETE: "delete",
};

// Giữ alias export cũ
export const LOYALTY_CONFIRM_ICON = LOYALTY_MODAL_ICON;
